import type { NuxtLinkProps } from "#app";

export function useLinkProps(rawUrl: MaybeRef<string | undefined | null>) {
  const { public: env } = useRuntimeConfig();

  return computed<NuxtLinkProps>(() => {
    let url = unref(rawUrl);
    const siteUrl = new URL(env.siteUrl);
    if (url?.startsWith(siteUrl.host)) {
      url = `https://${url}`;
    }

    if (url?.startsWith("http")) {
      try {
        const parsedUrl = new URL(url);

        if (parsedUrl.host === siteUrl.host) {
          return { to: parsedUrl.pathname };
        } else {
          return { to: parsedUrl.href, target: "_blank", rel: "noopener", external: true };
        }
      } catch (e) {
        handleError(e, `Invalid pitch link: ${url}`, false);
      }
    }

    return { to: url ?? undefined };
  });
}
